import api from './api';

const subscriptionPaymentService = {
  getAll: async (params = {}) => {
    const response = await api.get('/subscription-payments', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await api.get('/subscription-payments/stats');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/subscription-payments/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/subscription-payments', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/subscription-payments/${id}`, data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/subscription-payments/${id}`);
    return response.data;
  }
};

export default subscriptionPaymentService;
